import React from 'react';
import { CheckCircle, ArrowRight, Phone } from '@phosphor-icons/react';
import { HeroDashboard } from './HeroDashboard';
const clients = ['BP', 'Caltex', 'Thirsty Camel', 'Bottlemart', 'Camera House Albany', 'Kambalda Hotel', 'Ria Malaysian'];
export function Hero() {
  return <section className="relative bg-near-black pt-32 lg:pt-40 overflow-hidden flex flex-col" data-id="element-158">
      <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" data-id="element-159"></div>
      <div className="absolute top-1/4 -right-32 w-[500px] h-[500px] bg-knight-orange/5 rounded-full blur-3xl pointer-events-none" data-id="element-160"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pb-24 lg:pb-32 w-full" data-id="element-161">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center" data-id="element-162">
          <div className="lg:col-span-7 max-w-2xl reveal" data-id="element-163">
            <div className="inline-flex items-center px-3 py-1 rounded-full border border-hairline-dark mb-6" data-id="element-164">
              <span className="w-1.5 h-1.5 rounded-full bg-knight-orange mr-2" data-id="element-165"></span>
              <span className="font-mono text-[10px] tracking-wider uppercase text-gray-300" data-id="element-166">
                Perth and Sydney / IPA-supervised / Since 2014
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-[3.75rem] font-heading font-extrabold text-white leading-[1.05] tracking-tight mb-6" data-id="element-167">
              Bookkeeping and payroll, with the{' '}
              <span className="text-knight-orange" data-id="element-168">CFO thinking</span> most
              providers leave out.
            </h1>

            <p className="text-lg sm:text-xl text-gray-400 mb-8 leading-relaxed max-w-xl" data-id="element-169">
              Every Knight engagement is supervised by an IPA-recognised manager
              who thinks like a CFO. You get clean books, payroll on time and
              BAS handled, plus someone watching your numbers the way a CFO
              would. That is the difference.
            </p>

            <div className="flex flex-wrap gap-y-3 gap-x-5 mb-10" data-id="element-170">
              {['100% Australian-owned', '10+ years experience', 'IPA-supervised', 'Essential Eight-aligned', 'Fixed monthly fees'].map((item, i) => <div key={i} className="flex items-center text-sm text-gray-300" data-id="element-171">
                  <CheckCircle size={16} weight="regular" className="text-knight-orange mr-2 flex-shrink-0" data-id="element-172" />
                  {item}
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mb-4" data-id="element-173">
              <a href="#lead" className="inline-flex justify-center items-center px-6 py-4 text-base font-semibold rounded-md bg-knight-orange text-white hover:bg-knight-orange-hover transition-colors duration-300 ease-out-expo" data-id="element-174">
                Book a Free Consultation
                <ArrowRight size={18} weight="regular" className="ml-2" data-id="element-175" />
              </a>
              <a href="tel:+61863179998" className="inline-flex justify-center items-center px-6 py-4 text-base font-semibold rounded-md text-white border border-hairline-dark hover:bg-white/5 transition-colors duration-300 ease-out-expo" data-id="element-176">
                <Phone size={18} weight="regular" className="mr-2" data-id="element-177" />
                <span className="font-mono" data-id="element-178">+61 8 6317 9998</span>
              </a>
            </div>

            <p className="font-mono text-[11px] tracking-wide text-gray-500 uppercase" data-id="element-179">
              No startup costs / No lock-in / Fixed monthly fees / Cancel
              anytime
            </p>
          </div>

          <div className="lg:col-span-5 w-full mt-8 lg:mt-0" data-id="element-180">
            <HeroDashboard data-id="element-181" />
          </div>
        </div>
      </div>

      <div className="border-t border-hairline-dark bg-near-black relative z-10 mt-auto" data-id="element-182">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-183">
          <p className="text-center font-mono text-[10px] tracking-wider uppercase text-gray-500 mb-4" data-id="element-184">
            Trusted by Australian operators
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 lg:gap-x-12" data-id="element-185">
            {clients.map(c => <span key={c} className="font-heading font-bold text-sm lg:text-base text-white/40" data-id="element-186">
                {c}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}